import React from 'react';

import './Battery.scss';

function BatteryIcon({ percent, width, labeled, handleClick, hidden }) {
    const _widthWhole = width ? width : 30;
    const _height = _widthWhole * (12 / 8);
    const _width = _widthWhole - (_widthWhole / 5);
    let color = '#07e0ae';
    if (percent > 80) {
        color = '#07e0ae'
    } else if (percent > 60) {
        color = '#a5cf00'
    } else if (percent > 40) {
        color = '#f29800'
    } else if (percent > 20) {
        color = '#ff4242'
    } else {
        color = '#d30000'
    }
    if (labeled) {
        return (
            <div className={`__batLife ${!hidden ? '' : 'hidden'}`} onClick={() => !!handleClick ? handleClick() : null}>
                <div className="__batteryIcon" style={{ width: `${_width}px`, height: `${_height}px`, borderColor: color }}>
                    <div className="_batteryBorder">
                        <div className="_batteryValue" style={{ height: `${percent}%`, background: color }}></div>
                    </div>
                    <div className="_batteryCap" style={{ height: `${_width / 5}px`, borderColor: color, top: `-${(_width / 5) + 1}px`}}></div>
                </div>
                <span style={{color: color}}>
                    {(percent).toFixed(0)}%
                </span>
            </div>
        )
    } else {

        return (
            <div className={`__batLife ${!hidden ? '' : 'hidden'}`} onClick={() => !!handleClick ? handleClick() : null}>
                <div className="__batteryIcon" style={{ width: `${_width}px`, height: `${_height}px`, borderColor: color }}>
                    <div className="_batteryBorder">
                        <div className="_batteryValue" style={{ height: `${percent}%`, background: color }}></div>
                    </div>
                    <div className="_batteryCap" style={{ height: `${_width / 5}px`, borderColor: color, top: `-${(_width / 5) + 1}px` }}></div>
                </div>
            </div>
        )

    }
}

export default BatteryIcon;